import React from 'react';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';

export const DetailSender = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Contract.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="sender" className="pt-2 mb-3">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Pengirim
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            {data?.customer && (
              <ListHorizontal title="Customer" content={data?.customer?.name} />
            )}
            {data?.shipper && (
              <>
                <ListHorizontal title="Shipper" content={data?.shipper?.name} />
                <ListHorizontal
                  title="Contact"
                  content={data?.shipper?.phone}
                />
                <ListHorizontal
                  title="Alamat"
                  content={data?.shipper?.address}
                />
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};
